$(document).ready(function() {
	$(function() {
	  $('[data-toggle="tooltip"]').tooltip()
	});

	$('a[data-toggle="tooltip"]').click(function(e) {
		e.preventDefault();
	});

	createTippyTooltips();
	
});

function createTippyTooltips() {

	if (!$("html").hasClass("sc-edit-mode")) {
		$('.term-dialog-definition').each(function(){
		    $(this).prepend("<button type='button' class='close' aria-label='Close'>&times;</button>");
		});
	}


	tippy('.term-dialog-button', {
	  content(reference) {
	    const id = reference.getAttribute('data-template')
	    const linkedTemplate = document.getElementById(id)
	    const container = linkedTemplate.innerHTML
	    return container
	  },
	  theme: 'light',
	  arrow: true,
	  // Don't announce the tooltip's contents when expanded
	  aria: null,
	  trigger: "mouseenter click",
	  interactive: true,
	  hideOnClick: false,
	  delay: [100, 300],
	  flipBehavior: ["bottom", "left"],
	  appendTo: 'parent',
	  onMount({ reference }) {
	     reference.setAttribute('aria-expanded', 'true')
	  },
	  onHide({ reference }) {
	    reference.setAttribute('aria-expanded', 'false')
	  },
	  onShown(instance) {
	  	$(".close").on("click", function(event) {
	  		tippy.hideAll();
	  		return false;
	  	});
	  }
	});
}